import {
  FERRY_FILTERS_CHANGE,
  FERRY_FILTERS_RESET,
  FERRY_FILTERS_UPDATE,
  FERRY_SEARCH_FORM_CHANGE,
  FERRY_SEARCH_FORM_RESET,
  FERRY_SEARCH_FORM_UPDATE,
  FERRY_SEARCH_RESULTS_CHANGE,
  FERRY_SEARCH_RESULTS_IDLE,
  FERRY_SEARCH_RESULTS_LOADING,
  FERRY_SEARCH_RESULTS_RESET,
  FERRY_SEARCH_RESULTS_UPDATE,
  FERRY_SINGLE_FILTER_RESET,
  SELECTED_FERRY_CHANGE,
  SELECTED_FERRY_IDLE,
  SELECTED_FERRY_LOADING,
  SELECTED_FERRY_RESET,
  SELECTED_FERRY_UPDATE,
} from "./types";

// ==================== FERRY SEARCH FORM ========================
export const ferrySearchFormUpdate = ({ form }) => {
  return { type: FERRY_SEARCH_FORM_UPDATE, form };
};

export const ferrySearchFormChange = (key, value) => {
  return { type: FERRY_SEARCH_FORM_CHANGE, key, value };
};

export const ferrySearchFormReset = () => {
  return { type: FERRY_SEARCH_FORM_RESET };
};

// ================= FERRY SEARCH RESULTS ========================
export const ferrySearchResultsLoading = () => {
  return { type: FERRY_SEARCH_RESULTS_LOADING };
};

export const ferrySearchResultsIdle = () => {
  return { type: FERRY_SEARCH_RESULTS_IDLE };
};

export const ferrySearchResultsChange = (key, value) => {
  return { type: FERRY_SEARCH_RESULTS_CHANGE, key, value };
};

export const ferrySearchResultsUpdate = (results) => {
  return { type: FERRY_SEARCH_RESULTS_UPDATE, results };
};

export const ferrySearchResultsReset = () => {
  return { type: FERRY_SEARCH_RESULTS_RESET };
};

export const ferrySearchResultsFailed = () => {
  return { type: FERRY_SEARCH_RESULTS_CHANGE, key: "failed", value: true };
};

// ====================== FERRY FILTERS ==========================
export const ferryFiltersReset = () => {
  return { type: FERRY_FILTERS_RESET };
};

export const ferrySingleFilterReset = (key) => {
  return { type: FERRY_SINGLE_FILTER_RESET, key };
};

export const ferryFiltersChange = (key, value) => {
  return { type: FERRY_FILTERS_CHANGE, key, value };
};

export const ferryFiltersUpdate = (filters) => {
  return { type: FERRY_FILTERS_UPDATE, filters };
};

// =================== SELECTED FERRY =========================
export const ferrySelectedReset = () => {
  return { type: SELECTED_FERRY_RESET };
};

export const selectedFerryLoading = () => {
  return { type: SELECTED_FERRY_LOADING };
};

export const selectedFerryIdle = () => {
  return { type: SELECTED_FERRY_IDLE };
};

export const selectedFerryFailed = () => {
  return { type: SELECTED_FERRY_CHANGE, key: "failed", value: true };
};

export const selectedFerryChange = ({ key, value }) => {
  return { type: SELECTED_FERRY_CHANGE, key, value };
};

export const selectedFerryUpdate = (data) => {
  return { type: SELECTED_FERRY_UPDATE, data };
};
